import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { SelectPaymentModal } from '../select-payment-modal/select-payment-modal';
import { SelectAssetModal, SelectTokenInfo } from '../select-asset-modal/select-asset-modal.component';
import { WireTransferService } from 'src/app/angular-wallet-base/services/wire-transfer.service';
import { ASSETS, convertStringToTokenType, EPaymentMode, EPayWith, mapSelectTokenInfoToEPaymentMode, Metal, MIN_QTY_AGX_CRYPTOPAY, MIN_QTY_AGX_WIRETRANSFER, MIN_QTY_AUX_CRYPTOPAY, MIN_QTY_AUX_WIRETRANSFER, MIN_QTY_LODE_CRYPTOPAY, MIN_QTY_LODE_WIRETRANSFER, PAYMENT_CURRENCY_CODE, PAYMENT_CURRENCY_SYMBOL, PAYMENT_MODES, PAYWITH, TokenType, Unit } from 'src/app/angular-wallet-base/constants';
import BigNumber from 'bignumber.js';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { getBaseCurrency } from 'src/app/angular-wallet-base/store/userPreferences';
import { AddMetalComponent } from '../buy-assets/add-metal/add-metal.component';
import { LaravelResponse, MembersPortalService, TokenDetails } from '../../angular-wallet-base/services/members-portal.service';
import { ozToGramsNew, calculateLode, getTokenFiatValue, removeSpecialChars, setSwappingPairs, setUnit, presentToast, setCurrencyCode, getExchangeRate, getFormattedFiatAmountForDisplay } from '../../angular-wallet-base/utils';
import { CryptoTransferService } from 'src/app/angular-wallet-base/services/crypto-transfer.service';
import { DecimalPipe } from '@angular/common';
import { CreditDebitCardService } from 'src/app/angular-wallet-base/services/debit-credit-card.service';
import { SimplexCheckoutModalComponent } from './simplex-checkout/simplex-checkout';
import { BuildInfo } from '@awesome-cordova-plugins/build-info/ngx';
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { ThisReceiver } from '@angular/compiler';
import { ASSET_TOKEN, BankAccountService, tokenToAssetToken } from 'src/app/angular-wallet-base/services/bank-account.service';
import { WalletService } from 'src/app/angular-wallet-base/services/wallet.service';
import { getBankAccountBalance, getBankAssetsList } from 'src/app/angular-wallet-base/store/bankAccounts';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { AuthGuardService } from 'src/app/angular-wallet-base/services/auth-guard.service';
import { Asset } from '../../global';

interface CardOrder {
  grams: number;
  oz: number;
  metal_type: 'gold' | 'silver';
  user_message: string;
  equivalentgramsofgoldinsilver: number | void;
}

@Component({
  selector: 'buy-asset',
  templateUrl: './buy-assets.component.html',
  styleUrls: ['./buy-assets.component.scss']
})
export class BuyAssetsComponent extends SubscriptionListenerComponent implements OnInit {

  public isDesktopMode: boolean;
  public isTokenAmountChange: boolean;
  public asset: string;
  public assetName: string;
  public payWith: any;
  public payWithDisplayName: string;
  public form: FormGroup;
  public showNormalSelectPaymentField: boolean;
  public payWithDisplay: EPaymentMode;
  public limit;
  public showSpinner = false;

  // swap operation variables
  public amount;
  public slippageTolerance = '5';
  public swappingPair: string;
  public fiatValueOfToken1;
  public fiatValueOfToken2;
  public isNormalSwap: boolean;
  public routeSwapPair1: string;
  public routeSwapPair2: string;
  public tokenBalance: number;
  public swapNetwork: string;
  public tokenFrom: any;

  // bank transfer variables
  private getQuoteTimeout;
  public totalAmountSymbol = PAYMENT_CURRENCY_SYMBOL.USD_SYMBOL;
  public totalAmountCurrency = PAYMENT_CURRENCY_CODE.USD;
  public usdAmount: BigNumber = new BigNumber(0);
  public minimumValueErrorMessage = '';
  public invalidAmountErrorMessage = '';

  public tokenFiatValue;
  public feeAmount;
  public totalAmount = 0;
  public discount;
  public publicInfo;
  public lodeRateGrams;
  public exchangeRate = 0;
  public cart: any = [];
  public fiatCurrencyCode;
  public requestedCurrency;
  public assetImage: any;
  public placeHolder: string = '0.00';
  public oldFiatValue: string = null;
  public oldTokenValue: string = null;
  public newMember: boolean;
  public newMemberOfferData: any;
  public minimumValueError: boolean;
  public promoCode: string = null;
  public itemArr = [];
  public disableReviewBtn: boolean = true;
  public equivalentGramsToGold = 0;
  public showBuyList = true;
  private destinationWalletAddress: string;
  // prime wallet variables
  public fiat_to_token: boolean = true;
  public walletType;
  public fiatBalance;
  public assetsBalance;
  public exchangeAsset: string = '';
  public exchangePaywith: string = '';
  public payWithCrypto: string = '';
  constructor(
    public appMode: AppModeService,
    private nav: NavController,
    private modalController: ModalController,
    private route: ActivatedRoute,
    private wireTransferService: WireTransferService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private platform: Platform,
    private toast: ToastController,
    protected store: Store<AppState>,
    private membersPortalService: MembersPortalService,
    private cryptoTransferService: CryptoTransferService,
    private _decimalPipe: DecimalPipe,
    private creditDebitCardService: CreditDebitCardService,
    private oneInchService: OneInchService,
    private bankAccount: BankAccountService,
    private walletService: WalletService,
    private authService: AuthService,
    private authGuardService: AuthGuardService,
  ) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    this.walletType = this.walletService.getWalletType();
    this.asset = this.route.snapshot.params.asset;
    this.assetName = this.asset === 'LODE' ? this.asset + ' Token' : this.asset + ' Coin';
    this.store.select(getBaseCurrency).subscribe(currency => this.fiatCurrencyCode = currency);
    this.showNormalSelectPaymentField = true;
    this.initForm();
  }


  async ngOnInit() {
    await this.authService.dismissModal('select-payment-model');
    await this.authService.dismissModal('select-credit-model');
    this.exchangePrimeAssets();
    this.getFiatAndAssetBalance();
    this.publicInfo = await this.membersPortalService.getPublicInfo();
    // this.lodeRateGrams = this.publicInfo.data.lode_rate;

    this.setTokenSymbol();
    this.placeHolder = this.totalAmountSymbol + this.placeHolder;


    this.route.queryParams.subscribe(async (params) => {
      if(params.payWith) {
        this.payWithCrypto = params.payWith;
        this.payWith = params.payWith;
      }
      const buyData = this.authGuardService.selectedBuyData?.form;
      const reviewOrderDetails = buyData ? buyData : JSON.parse(await params.form);
      Logger.info(reviewOrderDetails);
      if (await params.promo || buyData?.promo) {
        const newPromo = buyData.promo ? buyData.promo : JSON.parse(await params.promo);
        this.promoCode = newPromo.promo;
        this.newMember = newPromo.newMember;
      }
      if (this.cart.length !== 0 && reviewOrderDetails.payWith === 'myMetals') {
        this.showBuyList = false;
      }
      this.initForm();
      if (reviewOrderDetails.payWith) {
        await this.setPayWithField(reviewOrderDetails.payWithDisplay ? reviewOrderDetails.payWithDisplay : reviewOrderDetails.payWith);
        this.setAllSelectedValues(reviewOrderDetails);
        this.form.get('payWith').setValue(this.payWith);
      }
      this.destinationWalletAddress = reviewOrderDetails.destinationWalletAddress ? reviewOrderDetails.destinationWalletAddress : this.destinationWalletAddress || '';
      this.assetImage = reviewOrderDetails.assetImage ? reviewOrderDetails.assetImage : undefined;
      this.isTokenAmountChange = reviewOrderDetails.isTokenAmountChange ? reviewOrderDetails.isTokenAmountChange : false;
      this.payWithDisplayName = reviewOrderDetails.payWithDisplay ? reviewOrderDetails.payWithDisplay : params.payWith ? params.payWith.toUpperCase() : '';
      this.showNormalSelectPaymentField = (
        this.payWith === PAYWITH.ETH ||
        this.payWith === PAYWITH.BTC || this.payWith === PAYWITH.USDC || this.payWith === PAYWITH.USDT 
      ) ? false : true;
      this.oldFiatValue = reviewOrderDetails.amountFiatDisplay ? reviewOrderDetails.amountFiatDisplay : null;
      this.oldTokenValue = reviewOrderDetails.amount ? reviewOrderDetails.amount : null;
      Logger.info('oldFiatValue ', this.oldFiatValue);
      Logger.info('oldTokenValue ', this.oldTokenValue);
      // for metals  
      this.cart = reviewOrderDetails.cart ? reviewOrderDetails.cart : [];
      if (this.cart.length !== 0 && reviewOrderDetails.payWith === PAYWITH.MyMetals) {
        this.calculateLodeValue();
        setTimeout(() => { this.showBuyList = true; }, 500);
      }

      if (reviewOrderDetails.amount) {
        this.form.patchValue({
          amount: reviewOrderDetails.amountOld ? reviewOrderDetails.amountOld : reviewOrderDetails.amount,
          amountFiat: reviewOrderDetails.amountFiatOld ? reviewOrderDetails.amountFiatOld : reviewOrderDetails.amountFiat,
          amountFiatDisplay: reviewOrderDetails.amountFiatDisplayOld ? reviewOrderDetails.amountFiatDisplayOld : removeSpecialChars(reviewOrderDetails.amountFiatDisplay),
          promo: this.promoCode,
          isNewUser: this.newMember,
          bones: null,
          payWith: reviewOrderDetails.payWith,
          payWithDisplay: reviewOrderDetails.payWithDisplay,
          token_fiat_value: reviewOrderDetails.token_fiat_value_old ? reviewOrderDetails.token_fiat_value_old : reviewOrderDetails.token_fiat_value,
          currencyCode: reviewOrderDetails.currencyCode,
          fiatCurrencyCode: reviewOrderDetails.fiatCurrencyCode,
          currencySymbol: reviewOrderDetails.currencySymbol,
          asset: reviewOrderDetails.asset,
          cart: reviewOrderDetails.cart,
          feeAmount: reviewOrderDetails.feeAmount_old ? reviewOrderDetails.feeAmount_old : reviewOrderDetails.feeAmount,
          amountCrypto: reviewOrderDetails.amountCryptoOld ? reviewOrderDetails.amountCryptoOld : reviewOrderDetails.amountCrypto,
          isTokenAmountChange: reviewOrderDetails.isTokenAmountChange,
          quoteId: null,
          amount_to_swap: reviewOrderDetails.amount_to_swap,
          swap_amount_fiat_display: reviewOrderDetails.swap_amount_fiat_display,
          swap_amount_fiat: reviewOrderDetails.swap_amount_fiat,
          priceImpact: reviewOrderDetails.priceImpact,
          minimumAmount: reviewOrderDetails.minimumAmount,
          slippageTolerance: reviewOrderDetails.slippageTolerance,
          swap_token_fiat_value: reviewOrderDetails.swap_token_fiat_value,
          swappingPair: reviewOrderDetails.swappingPair,
          routeSwapPair1: reviewOrderDetails.routeSwapPair1,
          routeSwapPair2: reviewOrderDetails.routeSwapPair2,
          isNormalSwap: reviewOrderDetails.isNormalSwap,
          feeAmount2: reviewOrderDetails.feeAmount2,
          paymentId: reviewOrderDetails.paymentId,
          swapNetwork: reviewOrderDetails.swapNetwork,
          tokenFrom: reviewOrderDetails.tokenFrom,
          destinationWalletAddress: reviewOrderDetails.destinationWalletAddress,
        });
      }
    });
  }

  getFiatAndAssetBalance() {
    // prime account fiat balance 
    if (this.walletType === 'prime') {
      this.subscriptions.add(this.store.select(getBankAccountBalance).subscribe((balanceState) => {
        this.fiatBalance = this.totalAmountSymbol + balanceState.amount;
      }));

      // token balance
      this.subscriptions.add(
        this.store.select(getBankAssetsList).subscribe(async (assets) => {
          this.assetsBalance = assets;
        })
      );
    }
  }
  getTokenBalance() {
    if (this.assetsBalance?.length > 0 && this.payWith?.length > 0) {
      if (this.assetsBalance.find(obj => obj.token.toLowerCase() === this.payWith)) {
        const tokenBalance = this.assetsBalance.find(obj => obj.token.toLowerCase() === this.payWith).balance;
        return tokenBalance;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  exchangePrimeAssets() {
    if (this.asset === 'AUX' || this.asset === 'AGX' || this.asset === 'LODE') {
      this.fiat_to_token = true;
    } else {
      this.fiat_to_token = false;
    }
  }
  initForm() {
    const amountFiatValidationPattern = `^[${this.totalAmountSymbol}]?[0-9]*\.?[0-9]*$`;
    this.form = this.formBuilder.group({
      amount: [null, [Validators.required, this.CheckMinimumQty(), Validators.pattern('^[0-9]*\.?[0-9]*$'), Validators.min(0)]],
      amountFiat: [null, Validators.required],
      amountFiatDisplay: [null, [Validators.pattern(amountFiatValidationPattern), Validators.min(0)]],
      promo: [this.promoCode],
      isNewUser: [this.newMember],
      payWith: ['', [Validators.required]],
      payWithDisplay: [''],
      token_fiat_value: [''],
      swap_token_fiat_value: [''],
      currencyCode: [this.fiatCurrencyCode],
      fiatCurrencyCode: [this.fiatCurrencyCode],
      currencySymbol: [''],
      asset: [this.asset],
      cart: [this.cart],
      feeAmount: [''],
      feeAmount2: [null],
      amountCrypto: [''],
      amount_to_swap: [null, [this.CheckMaxQty()]],
      swap_amount_fiat_display: [''],
      swap_amount_fiat: [''],
      slippageTolerance: [this.slippageTolerance],
      isTokenAmountChange: [false],
      quoteId: [''],
      priceImpact: [''],
      minimumAmount: [''],
      swappingPair: [''],
      routeSwapPair1: [''],
      routeSwapPair2: [''],
      isNormalSwap: [''],
      assetImage: [''],
      paymentId: [''],
      swapNetwork: [''],
      tokenFrom: [''],
      destinationWalletAddress: [''],
      fiat_to_token: [this.fiat_to_token],
      primeRate: ['']
    });
  }

  setTokenSymbol() {
    this.totalAmountSymbol = setCurrencyCode(this.fiatCurrencyCode);
    this.form.get('currencySymbol').setValue(this.totalAmountSymbol);
    this.totalAmountCurrency = this.form.get('fiatCurrencyCode').value;
  }

  isAddingDisabled() {
    return this.form.invalid;
  }

  async selectPayment() {
    const cssClass = (this.isDesktopMode) ? 'select-asset-modal-desktop' : 'select-asset-modal';
    const modal = await this.modalController.create({
      component: SelectPaymentModal,
      componentProps: {
        selectedToken: this.asset
      },
      cssClass,
      id: 'select-payment-model',
      backdropDismiss: false,
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.9,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.6, 0.9, 1],
    });
    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.setAllSelectedValues(data.data.selectType);
      }
    });
    await modal.present();
    await modal.onDidDismiss().then(async (res) => {
      Logger.info(res);
      this.setAllSelectedValues(res.data.selectType);
    });
  }
  async setAllSelectedValues(res) {
    if (res !== undefined) {
      this.payWithDisplay = res.payWithDisplay ? res.payWithDisplay : res.payWith;
      this.swapNetwork = res.baseChainSymbol ? res.baseChainSymbol : '';
      this.tokenFrom = res.tokenFrom ? res.tokenFrom : '';
      setTimeout(async () => {
        this.assetImage = res.path !== undefined ? res.path : '';
        await this.setPayWithField(this.payWithDisplay);
      }, 500);
      if (this.payWith !== undefined && this.payWithDisplay !== res.payWith) {
        this.initForm();
      }
      this.form.get('swapNetwork').setValue(this.swapNetwork);
      this.form.get('tokenFrom').setValue(this.tokenFrom.assetGuid);
      this.form.get('payWithDisplay').setValue(this.payWithDisplay);
      this.form.get('payWith').setValue(this.payWith);
      this.fiatValueOfToken1 = res.fiatValue ? res.fiatValue : 1;
      this.fiatValueOfToken2 = res.selectedTokenFiatValue ? res.selectedTokenFiatValue : 1;
      this.tokenBalance = res.totalBalance ? res.totalBalance : 1;
      if (this.payWith === 'myMetals') {
        this.form.get('amount').setValue(null);
        this.form.get('amountFiatDisplay').setValue(null);
      }
    }
  }
  async setPayWithField(payWithDisplay: EPaymentMode) {
    switch (payWithDisplay) {
      case PAYMENT_MODES.BANK_TRANSFER:
        this.payWith = PAYWITH.BankTransfer;
        this.showNormalSelectPaymentField = true;
        this.onTokenAmountChangeBankTransfer();
        break;
      case PAYMENT_MODES.MY_METALS:
        let quote = null;
        try {
          quote = await this.membersPortalService.getPriceQuoteForMetaPayment('10', '', '1', this.fiatCurrencyCode, this.asset, this.isTokenAmountChange);
          const lodeRate = this.publicInfo?.data?.lode_rate;
          const assetToken = convertStringToTokenType(this.asset);
          this.exchangeRate = getExchangeRate(assetToken, parseFloat(quote?.data?.spot_price), lodeRate);
          this.payWith = PAYWITH.MyMetals;
          this.showNormalSelectPaymentField = true;
        } catch (error) {
          const title = await this.translate.get('buy_assets.failed').toPromise();
          const dec = await this.translate.get('buy_assets.failed_message').toPromise();
          presentToast(title, dec, this.translate, this.toast, this.platform, true);
          Logger.error('Quote Error for mymetal', error);
        }
        break;
      case PAYMENT_MODES.CREDIT_DEBIT_CARD:
        this.payWith = PAYWITH.Silver_Card;
        this.showNormalSelectPaymentField = true;
        this.form.get('destinationWalletAddress').setValue(this.destinationWalletAddress);
        this.onTokenAmountChangeCreditDebitCard();
        break;
      case PAYMENT_MODES.CRYPTO:
        this.payWith = this.payWith;
        this.form.get('destinationWalletAddress').setValue(this.destinationWalletAddress);
        this.showNormalSelectPaymentField = false;
        this.onTokenAmountChangePayByCrypto();
        break;
      case PAYMENT_MODES.USD_BALANCE:
        this.payWith = PAYWITH.USDBalance;
        this.showNormalSelectPaymentField = true;
        this.fiat_to_token ? this.onFiatChange() : this.onTokenToFiatAmountChange();
        break;
      case PAYMENT_MODES.AGX:
        this.payWith = PAYWITH.AGX;
        this.showNormalSelectPaymentField = true;
        this.fiat_to_token ? this.onTokenToFiatAmountChange() : this.onFiatChange();
        break;
      case PAYMENT_MODES.AUX:
        this.payWith = PAYWITH.AUX;
        break;
      case PAYMENT_MODES.LODE:
        this.payWith = PAYWITH.LODE;
        this.showNormalSelectPaymentField = true;
        this.fiat_to_token ? this.onTokenToFiatAmountChange() : this.onFiatChange();
        break;
      default:
        this.payWith = '';
        break;
    }
    this.form.controls.amount.updateValueAndValidity();
  }

  setAmountZeroIfNotMetMinimum(amount) {
    this.minimumValueError = false;

    if (this.isTokenAmountChange) {
      if (this.payWith === PAYWITH.BankTransfer) {
        if (this.asset === ASSETS.LODE && (amount == null || Number(amount) < MIN_QTY_LODE_WIRETRANSFER)) {
          return false;
        }
        else if ((this.asset === ASSETS.AUX) && (amount == null || Number(amount) < MIN_QTY_AUX_WIRETRANSFER)) {
          return false;
        }
        else if ((this.asset === ASSETS.AGX) && (amount == null || Number(amount) < MIN_QTY_AGX_WIRETRANSFER)) {
          return false;
        }
        else {
          return true;
        }
      }
      else if (this.payWith === PAYWITH.BTC || this.payWith === PAYWITH.ETH || this.payWith === PAYWITH.USDC || this.payWith === PAYWITH.USDT) {
        if (this.asset === ASSETS.LODE && (amount == null || Number(amount) < MIN_QTY_LODE_CRYPTOPAY)) {
          return false;
        }
        else if ((this.asset === ASSETS.AUX) && (amount == null || Number(amount) < MIN_QTY_AUX_CRYPTOPAY)) {
          return false;
        }
        else if ((this.asset === ASSETS.AGX) && (amount == null || Number(amount) < MIN_QTY_AGX_CRYPTOPAY)) {
          return false;
        }
        else {
          return true;
        }
      }
    }
    else {
      return true;
    }
  }

  async selectAsset() {
    const cssClass = (this.isDesktopMode) ? 'select-asset-modal-desktop' : 'select-asset-modal';
    const modal = await this.modalController.create({
      component: SelectAssetModal,
      componentProps: {
        actionType: 'changeSelectionAch'
      },
      cssClass,
      id: 'select-asset-model',
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.9,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.6, 0.9, 1],
    });
    modal.onDidDismiss().then((data) => {
      if (data.data?.asset) {
        //map SelectTokenInfo to payWith
        const paymentMode = mapSelectTokenInfoToEPaymentMode(data.data.asset);
        this.setPayWithField(paymentMode);
        this.form.get('payWith').setValue(this.payWith);
      }
    });
    await modal.present();
  }

  goBack() {
    const previousUrl = this.authService.getPreviousUrl();
    Logger.info(previousUrl);
    if (previousUrl.includes('/home-page/established') || previousUrl.includes('/buy-assets/')) {
      this.nav.navigateRoot(['/home-page/established']);
    } else {
      this.nav.back();
    }
  }

  reviewOrder() {
    this.form.get('assetImage').setValue(this.assetImage);
    if (this.payWith === PAYWITH.Silver_Card &&
      this.form.get('amountFiatDisplay').value !== this.oldFiatValue &&
      this.form.get('amount').value !== this.oldTokenValue) {
      this.form.get('paymentId').setValue(undefined);
      Logger.info(this.form.value);
    }
    this.authGuardService.setSelectedBuyData(null);
    this.nav.navigateForward(['/buy-assets/review-order'], { queryParams: { form: JSON.stringify(this.form.value), } });
  }

  onFiatAmountChange(e) {
    if ((removeSpecialChars(e.target.value) === removeSpecialChars(this.oldFiatValue)) || e.target.value === '') {
      return;
    }
    const amt = +(removeSpecialChars(e.target.value));
    this.calculateTokenAgainstFiatAmount(amt);
  }
  calculateTokenAgainstFiatAmount(amount) {
    this.isTokenAmountChange = false;
    this.form.patchValue({
      amountFiatDisplay: removeSpecialChars(amount),
      isTokenAmountChange: this.isTokenAmountChange,
      amount: null,
      amountFiat: amount
    });
    this.oldFiatValue = amount;
    if (this.payWith === PAYWITH.BankTransfer) {
      this.onTokenAmountChangeBankTransfer(amount);
    }
    else if (this.payWith == PAYWITH.BTC || this.payWith == PAYWITH.ETH || this.payWith == PAYWITH.USDC || this.payWith == PAYWITH.USDT) {
      this.onTokenAmountChangePayByCrypto(amount);
    }
    else if (this.payWith === PAYWITH.Silver_Card) {
      this.onTokenAmountChangeCreditDebitCard(amount);
    } else if (this.walletType === 'prime' && this.fiat_to_token) {
      this.setPayWithField(EPaymentMode.USDBalance);
      this.form.patchValue({
        payWith: this.payWith
      });
      this.onFiatChange();
    }
  }

  onTokenAmountChange(e) {
    Logger.info('onTokenAmountChange', e.target.value,this.oldTokenValue)
    if (e.target.value === this.oldTokenValue || e.target.value === '') {
      this.form.patchValue({
        amountFiatDisplay: null
      });
      return;
    }
    this.calculateFiatAgainstTokenAmount(e.target.value);
  }
  calculateFiatAgainstTokenAmount(amount) {
    this.isTokenAmountChange = true;
    this.form.patchValue({
      amountFiatDisplay: null,
      isTokenAmountChange: this.isTokenAmountChange,
      amountCrypto: null,
      amountFiat: null,
    });
    this.oldTokenValue = amount;
    if (this.payWith === PAYWITH.BankTransfer) {
      this.onTokenAmountChangeBankTransfer(amount);
    }
    else if (this.payWith === PAYWITH.ETH || this.payWith === PAYWITH.BTC || this.payWith === PAYWITH.USDC || this.payWith === PAYWITH.USDT) {
      this.onTokenAmountChangePayByCrypto(amount);
    }
    else if (this.payWith === PAYWITH.Silver_Card) {
      this.onTokenAmountChangeCreditDebitCard(amount);
    } else if (this.walletType === 'prime') {
      this.onTokenToFiatAmountChange();
    }
  }

  // pay by bank transfer operations//
  CheckMinimumQty = (): ValidatorFn => {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (this.payWith === PAYWITH.BankTransfer) {
        if (this.asset === ASSETS.LODE && (isNaN(parseInt(c.value)) || parseInt(c.value) < MIN_QTY_LODE_WIRETRANSFER)) {
          this.limit = MIN_QTY_LODE_WIRETRANSFER;
          return { minValue: true };
        }
        else if ((this.asset === ASSETS.AUX) && (isNaN(parseInt(c.value)) || parseInt(c.value) < MIN_QTY_AUX_WIRETRANSFER)) {
          this.limit = MIN_QTY_AUX_WIRETRANSFER;
          return { minValue: true };
        }
        else if ((this.asset === ASSETS.AGX) && (isNaN(parseInt(c.value)) || parseInt(c.value) < MIN_QTY_AGX_WIRETRANSFER)) {
          this.limit = MIN_QTY_AGX_WIRETRANSFER;
          return { minValue: true };
        }
      }
      else if (this.payWith === PAYWITH.BTC || this.payWith === PAYWITH.ETH || this.payWith === PAYWITH.USDC || this.payWith === PAYWITH.USDT) {
        if (this.asset === ASSETS.LODE && (isNaN(parseInt(c.value)) || parseInt(c.value) < MIN_QTY_LODE_CRYPTOPAY)) {
          this.limit = MIN_QTY_LODE_CRYPTOPAY;
          return { minValue: true };
        }
        else if ((this.asset === ASSETS.AUX) && (isNaN(parseInt(c.value)) || parseInt(c.value) < MIN_QTY_AUX_CRYPTOPAY)) {
          this.limit = MIN_QTY_AUX_CRYPTOPAY;
          return { minValue: true };
        }
        else if ((this.asset === ASSETS.AGX) && (isNaN(parseInt(c.value)) || parseInt(c.value) < MIN_QTY_AGX_CRYPTOPAY)) {
          this.limit = MIN_QTY_AGX_CRYPTOPAY;
          return { minValue: true };
        }
      }
      return null;
    };
  }

  CheckMaxQty = (): ValidatorFn => {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      if ((isNaN(c.value) || parseInt(c.value) > this.tokenBalance)) {
        return { maxValue: true };
      }
    };
  }


  onTokenAmountChangeBankTransfer(amount?: number) {
    let readOnly: string = '1';
    // clear the previous timeout to prevent additional requests
    clearTimeout(this.getQuoteTimeout);

    if (!amount) {
      return;
    }

    if (this.setAmountZeroIfNotMetMinimum(amount)) {
      const FETCH_QUOTE_TIMEOUT = 500;
      this.showSpinner = true;
      this.getQuoteTimeout = setTimeout(async () => {

        // Set timeout to prevent too many requests.
        let quote: any;
        try {
          if (this.newMember !== true) {
            readOnly = '0';
          }
          quote = await this.wireTransferService.getPriceQuoteTransaction(
            amount.toString(),
            this.promoCode,
            readOnly,
            this.fiatCurrencyCode,
            this.asset,
            this.isTokenAmountChange
          );
          Logger.info(quote);
          this.form.patchValue({
            fiatCurrencyCode: quote.data.currency_code,
            currencyCode: quote.data.currency_code,
            token_fiat_value: quote.data.premium ? quote.data.premium : quote.data.base_premium,
            amountFiatDisplay: this.isTokenAmountChange ? (this.totalAmountSymbol + (quote.data.price_total_before_discount ? quote.data.price_total_before_discount : quote.data.price_total)) : (this.totalAmountSymbol + this.form.get('amountFiatDisplay').value),
            amountFiat: this.isTokenAmountChange ? (quote.data.price_total_before_discount ? quote.data.price_total_before_discount : quote.data.price_total) : (removeSpecialChars(this.form.get('amountFiatDisplay').value)),
            amount: this.isTokenAmountChange ? this.form.get('amount').value : quote.data.qty.toFixed(2),
          });
          if (this.isTokenAmountChange) {
            this.oldFiatValue = this.form.get('amountFiatDisplay').value;
          } else {
            this.oldTokenValue = this.form.get('amount').value;
          }
          this.showSpinner = false;
          this.minimumValueError = false;
        } catch (err) {
          if (err.error.error) {
            // this.minimumValueError = true;
            const errorMessage = err.error.error;
            this.minimumValueErrorMessage = errorMessage;
            this.showSpinner = false;
          }
          return;
        }
       
      }, FETCH_QUOTE_TIMEOUT);
    }
  }

  // pay by crypto operations//
  async onTokenAmountChangePayByCrypto(amt?: number) {
    let readOnly: string = '1';
    clearTimeout(this.getQuoteTimeout);

    if (!amt) {
      return;
    }
    this.setTokenSymbol();
    if (this.setAmountZeroIfNotMetMinimum(amt)) {
      const FETCH_QUOTE_TIMEOUT = 500;
      this.getQuoteTimeout = setTimeout(async () => {
        this.showSpinner = true;
        let quote: any;
  
        try {
          if (this.newMember !== true) {
            readOnly = '0';
          }
          quote = await this.cryptoTransferService.getPriceQuoteTransaction(
            amt.toString(),
            this.payWith.toUpperCase(),
            this.promoCode,
            readOnly,
            this.fiatCurrencyCode,
            this.asset,
            this.isTokenAmountChange
          );
        } catch (err) {
          if (err.error.error) {
            this.minimumValueError = true;
            const errorMessage = err.error.error;
            this.minimumValueErrorMessage = errorMessage;
            this.form.get('amountCrypto').setValue(null);
            this.oldFiatValue = null;
            this.oldTokenValue = null;
            this.showSpinner = false;
          }
          return;
        }
        Logger.info("pricequote",quote);
        this.form.patchValue({
          feeAmount: quote.data.fee_amount,
          fiatCurrencyCode: quote.data.currency_code,
          currencyCode: quote.data.currency_code,
          token_fiat_value: parseFloat(quote.data.premium),
          // amountFiatDisplay: this.totalAmountSymbol + parseFloat(quote.data.fiat_price_total),
          amountFiatDisplay: this.isTokenAmountChange ? (this.totalAmountSymbol + Number(quote.data.fiat_price_total).toFixed(2)) : (this.totalAmountSymbol + this.form.get('amountFiatDisplay').value),
          // amountFiat: parseFloat(quote.data.fiat_price_total),
          amountFiat: this.isTokenAmountChange ? (Number(quote.data.fiat_price_total).toFixed(2)) : (removeSpecialChars(this.form.get('amountFiatDisplay').value)),
          // amount: parseFloat(quote.data.qty).toFixed(2),
          amount: this.isTokenAmountChange ? this.form.get('amount').value : quote.data.qty.toFixed(2),
          amountCrypto: this._decimalPipe.transform(quote.data.price_total, '1.2-4'),
          quoteId: quote.data?.quote_id,
        });
        this.oldFiatValue = this.form.get('amountFiatDisplay').value;
        this.oldTokenValue = this.form.get('amount').value;
        this.showSpinner = false;
        this.minimumValueError = false;
      }, FETCH_QUOTE_TIMEOUT);
    }
  }

  // pay by metals operations//
  async calculateLodeValue() {
    this.showSpinner = true;
    let amount = 0;
    let fiat_amount = 0;
    this.itemArr = [];
    this.equivalentGramsToGold = 0;
    this.cart.length !== 0 ? this.form.get('amount').setValue(0) : this.form.get('amount').setValue('');
    this.cart.length !== 0 ? this.form.get('amountFiatDisplay').setValue(this.totalAmountSymbol + 0) : this.form.get('amountFiatDisplay').setValue('');

    // this.form.get('amountFiatDisplay').setValue(this.totalAmountSymbol + 0);
    if (this.cart) {
      this.itemArr = await Promise.all(this.cart.map(async element => {
        let tempAmount = 0;
        const totalWeight = (parseFloat(element.qty) * parseFloat(element.weight));
        //convert this.asset to TokenType
        const tokenType = convertStringToTokenType(this.asset);
        const metalType = element.type === 'gold' ? Metal.GOLD : Metal.SILVER;
        let tokenAmount;
        try {
          tokenAmount = await this.getTokenRate(tokenType, totalWeight, metalType);
        } catch (err) {
          this.showSpinner = false;
          Logger.error('Error in getting asset rate', err);
          return;
        }
        amount = amount + tokenAmount;
        this.form.get('amount').setValue(amount.toFixed(2));
        tempAmount = tempAmount + tokenAmount;
        fiat_amount = fiat_amount + this.exchangeRate * tempAmount;
        this.form.get('amountFiat').setValue(this.getRoundNumber2decimals(fiat_amount));
        this.form.get('amountFiatDisplay').setValue(getFormattedFiatAmountForDisplay(this.fiatCurrencyCode, this.getRoundNumber2decimals(fiat_amount)));
        if (element.type == 'gold') {
          const convertedGoldValue = this.convertGoldGramsInSilver(ozToGramsNew(totalWeight));
          this.equivalentGramsToGold = this.equivalentGramsToGold + convertedGoldValue;
        }
        if (element.type == 'silver') {
          this.equivalentGramsToGold = this.equivalentGramsToGold + ozToGramsNew(totalWeight);
        }
        return element;
      }));
    }
    this.showSpinner = false;
    this.form.get('cart').setValue(this.cart);
    this.disableReviewBtn = this.equivalentGramsToGold < 3110 ? true : false;
    //What is the purpose for this?
    // if (this.newMember) {
    //   const data: any = await this.membersPortalService.createBullionOrder(this.itemArr, 1, this.promoCode, null);
    //   const amt = parseInt(data.data.quote.totalTokensAfterPromo);
    //   this.form.get('amount').setValue(amt.toFixed(2));
    //   this.form.get('bones').setValue(data.data.quote.bonusTokens);
    // }
  }

  convertGoldGramsInSilver(val) {
    return val * this.publicInfo.data.gold_silver_ratio;
  }

  getRoundNumber2decimals(num) {
    return Math.round(num * 100) / 100;
  }

  async addMetalModal(item?) {
    this.showBuyList = false;
    const cssClass = (this.isDesktopMode) ? 'select-asset-modal-desktop' : 'select-asset-modal';
    const modal = await this.modalController.create({
      component: AddMetalComponent,
      componentProps: {
        editValue: item ? item : ''
      },
      cssClass,
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.9,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.6, 0.9, 1],
    });
    modal.onDidDismiss()
      .then((res) => {
        if (res.data) {
          this.cart.push(res.data[0]);
          this.calculateLodeValue();
        }
        setTimeout(() => { this.showBuyList = true; }, 500);
      });
    return await modal.present();
  }

  async handleCartData(val) {
    this.cart = val;
    this.calculateLodeValue();
  }


  /**
   * Get the rate of a token.
   * @returns 
   */
  async getTokenRate(token: TokenType, ozTotal: number, metal: Metal): Promise<number> {
    const response: LaravelResponse = await this.membersPortalService.getEquivalentTokenAmountFromWeight(token, Unit.TROY_OUNCE, ozTotal, metal);
    this.showSpinner = false;
    return response?.data;
  }

  capitalizeString(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // swap operations
  clearFormForSwap() {
    this.form.patchValue({
      amountFiat: null,
      amount: null,
      swap_amount_fiat_display: null,
      swap_amount_fiat: null,
      amount_to_swap: null,
      swappingPair: null,
      isNormalSwap: null,
      swapNetwork: null
    });
    this.swappingPair = '';
  }


  getTokenFiatValue(fiatRate, amt) {
    return getTokenFiatValue(fiatRate, amt);
  }

  // credit/debit operations
  async opensimplex() {
    const cssClass = (this.isDesktopMode) ? 'simplex-widget-modal-desktop' : 'simplex-widget-modal';
    const modal = await this.modalController.create({
      component: SimplexCheckoutModalComponent,
      cssClass,
      backdropDismiss: false,
      id: 'simplex-checkout-modal'
    });
    await modal.present();
  }

  async onTokenAmountChangeCreditDebitCard(amt?: number) {
    // this.invalidAmountErrorMessage = '';
    // this.form.get('amountFiat').setErrors(null);

    let asset: string = '';
    if (!amt) {
      return;
    }
    let targetCurrency: string = '';
    let sourceCurrency: string = '';
    if (this.isTokenAmountChange) {
      sourceCurrency = this.asset === 'AVAX' ? 'AVAX-C' : this.asset;
      asset = this.asset === 'AVAX' ? 'AVAX-C' : this.asset;
      targetCurrency = this.fiatCurrencyCode;
    } else { // fiat amount change
      amt = removeSpecialChars(this.form.get('amountFiatDisplay').value);
      sourceCurrency = this.fiatCurrencyCode;
      targetCurrency = this.asset === 'AVAX' ? 'AVAX-C' : this.asset;
      asset = this.asset === 'AVAX' ? 'AVAX-C' : this.asset;
    }
    if (amt > 0) {
      this.minimumValueError = false;
      this.showSpinner = true;
      let quote: any;
      try {
        console.log({asset, sourceCurrency, targetCurrency, isTokenAmountChange: this.isTokenAmountChange})
        quote = await this.creditDebitCardService.getPriceQuoteTransaction(
          asset,
          this.fiatCurrencyCode,
          sourceCurrency,
          +amt
        );
        Logger.info('getPriceQuoteTransaction', quote);
        if (quote && quote.fiat_money && !quote.errors) {
          this.form.patchValue({
            fiatCurrencyCode: quote.fiat_money.currency,
            currencyCode: quote.digital_money.currency,
            token_fiat_value: 0.7713,
            amountFiatDisplay: this.totalAmountSymbol + (quote.fiat_money.total_amount),
            amountFiat: parseFloat(quote.fiat_money.total_amount),
            amount: parseFloat(quote.digital_money.amount).toFixed(5),
            quoteId: quote.quote_id,
            paymentId: undefined,
          });
          this.oldFiatValue = this.form.get('amountFiatDisplay').value;
          this.oldTokenValue = this.form.get('amount').value;
          this.minimumValueError = false;
        } else if(quote && quote.errors) {
          this.form.get('amountFiat').setErrors({ 'invalidAmount': true });
          this.invalidAmountErrorMessage = quote.errors;
          this.showSpinner = false;
        } else {
          this.showSpinner = false;
        }
      } catch (error) {
        Logger.error(error);
        this.showSpinner = false;
      }
      this.showSpinner = false;
    }
  }

  async onFiatChange() {
    // clear the previous timeout to prevent additional requests

    clearTimeout(this.getQuoteTimeout);
    const FETCH_QUOTE_TIMEOUT = 500;
    const token: ASSET_TOKEN = this.asset === 'AUX' ? 'aux' : this.asset === 'AGX' ? 'agx' : this.asset === 'USD' ? this.payWith.toUpperCase() : 'lode';
    this.minimumValueError = false;
    const fiatAmount = Number(parseFloat(this.oldFiatValue));

    if (isNaN(fiatAmount) || fiatAmount === null) {
      this.showSpinner = false;
      return;
    }
    if (fiatAmount > removeSpecialChars(this.fiatBalance)) {
      this.minimumValueError = true;
      this.minimumValueErrorMessage = 'Sorry ,you don\'t have enough funds to exchange';
      return;
    }

    this.getQuoteTimeout = setTimeout(async () => {
      try {
        this.showSpinner = true;
        const newTokenAmount = await this.bankAccount.getTokenRate({
          token: tokenToAssetToken(token),
          amount: fiatAmount
        });

        this.showSpinner = false;
        this.minimumValueError = false;
        this.form.patchValue({
          amountFiatDisplay: this.totalAmountSymbol + fiatAmount
        });
        this.form.patchValue({
          amount: newTokenAmount
        });
        this.getPrimeRate();
      } catch (err) {
        this.showSpinner = false;
        this.form.patchValue({
          amount: ''
        });
        // Logger.error('onFiatChange: ', err);
        return;
      }
    }, FETCH_QUOTE_TIMEOUT);

  }

  async onTokenToFiatAmountChange() {
    const tokenBalance = this.assetsBalance.find(obj => obj.token.toLowerCase() === this.payWith).balance;
    clearTimeout(this.getQuoteTimeout);
    const FETCH_QUOTE_TIMEOUT = 500;
    const token = this.asset === 'AUX' ? 'aux' : this.asset === 'AGX' ? 'agx' : this.asset === 'USD' ? this.payWith.toUpperCase() : 'lode';
    const tokenAmount = Number(parseFloat(this.oldTokenValue));
    if (tokenAmount > tokenBalance) {
      this.minimumValueError = true;
      this.minimumValueErrorMessage = '***Sorry ,you don\'t have enough funds to exchange';
      return;

    }
    if (tokenAmount > 0) {
      this.minimumValueError = false;
      this.getQuoteTimeout = setTimeout(async () => {
        try {
          this.showSpinner = true;
          const newFiatAmount = await this.bankAccount.getTokentoFiatRate({
            token: tokenToAssetToken(token),
            amount: tokenAmount
          });
          this.showSpinner = false;
          if (newFiatAmount === 'NaN') {
            this.minimumValueError = true;
            this.minimumValueErrorMessage = '***This pair is not supported yet';
            // this.presentToast('settings.toast_msgs.err_hdr','bank_account.move_funds_modal.unsupported_pair_msg'); 
            return;
          }
          this.form.patchValue({
            amountFiat: newFiatAmount,
            amountFiatDisplay: this.totalAmountSymbol + newFiatAmount
          });
          this.getPrimeRate();
        } catch (err) {
          this.showSpinner = false;
          this.form.patchValue({
            amountFiatDisplay: ''
          });
          Logger.info('onTokenChange: ', err);
          // Logger.error('onTokenChange: ', err);
          return;
        }
      }, FETCH_QUOTE_TIMEOUT);
    }
  }
  swapExchange() {
    if (this.payWith?.length > 0) {
      this.fiat_to_token = !this.fiat_to_token;
      this.form.patchValue({
        fiat_to_token: this.fiat_to_token
      });

      this.exchangeAsset = this.asset;
      this.exchangePaywith = this.payWith;
      this.payWith = this.asset === 'USD' ? 'usdBalance' : this.asset.toLowerCase();
      this.asset = this.exchangePaywith === 'usdBalance' ? 'USD' : this.exchangePaywith.toLocaleUpperCase();
    }
  }

  async getPrimeRate() {
    if (this.fiat_to_token) {
      try {
        const newTokenAmount = await this.bankAccount.getTokenRate({
          token: tokenToAssetToken(this.asset),
          amount: 1
        });
        this.form.patchValue({
          primeRate: newTokenAmount
        });
      } catch (err) {
        Logger.info(err);
      }

    } else {
      try {
        const newFiatAmount = await this.bankAccount.getTokentoFiatRate({
          token: tokenToAssetToken(this.asset),
          amount: 1
        });
        this.form.patchValue({
          primeRate: newFiatAmount
        });
      } catch (err) {
        Logger.info(err);
      }
    }
  }
}
